import { Grid, MenuItem, Paper, Select } from "@mui/material";
import EditFormControl from "components/form/EditFormControl";
import SimpleProgressCard from "components/SimpleProgressCard";
import CustomText from "components/typography/CustomText";
import { ERR_NETWORK } from "constants/messages";
import { formatArray, groupBy } from "lib/arrayObject";
import {
  getCurrentWeekNum,
  getCurrentYearNum,
  getWeekDaysByWeekNumber,
  weekCount,
} from "lib/date";
import { toNumber } from "lib/math";
import { isEmpty } from "lodash";
import { getWeeklySlots } from "models/weeklySlotsModel";
import { useSnackbar } from "notistack";
import { useEffect, useMemo, useState } from "react";
import { openLoading } from "store/reducers/tools";

export default function PopularFlavours() {
  const { enqueueSnackbar } = useSnackbar();
  const [pies, setPies] = useState({});
  const [selWeek, setSelWeek] = useState({});
  const [totalPies, setTotalPies] = useState(0);
  const [selYear, setSelYear] = useState(getCurrentYearNum());

  const errorAction = (res, err) => {
    if (!res && err?.message) {
      enqueueSnackbar(err?.message, { variant: "warning" });
    } else {
      enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
    }
  };

  const years = useMemo(() => {
    const cur_year = getCurrentYearNum();
    return Array.from(Array(4).keys()).reduce(
      (ret, cur) => [...ret, cur_year - cur],
      [cur_year + 1]
    );
    //eslint-disable-next-line
  }, [selYear]);

  const weeks = useMemo(() => {
    const cur_year = getCurrentYearNum();
    const weeklyInfos = Array.from(Array(weekCount).keys()).reduce(
      (ret, cur, index) => {
        const label = `Week ${cur + 1} (${getWeekDaysByWeekNumber({
          weekNumber: cur + 1,
          addDay: 0,
          format: "DD MMM",
          yearNumber: selYear ?? cur_year,
        })} ~ ${getWeekDaysByWeekNumber({
          weekNumber: cur + 1,
          addDay: 6,
          format: "DD MMM",
          yearNumber: selYear ?? cur_year,
        })})`;
        return [...ret, { id: cur + 1, label: label }];
      },
      []
    );
    setSelWeek(() => weeklyInfos[selWeek?.id ?? getCurrentWeekNum() - 1]);
    return weeklyInfos;
    //eslint-disable-next-line
  }, [selYear]);

  const loadData = () => {
    openLoading(true);
    getWeeklySlots({
      data: {
        week_num: selWeek?.id,
        week_year: selYear ?? getCurrentYearNum(),
      },
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) {
          errorAction(res, err);
          return;
        }
        const totalPies = formatArray(res).reduce(
          (ret, cur) => [...ret, ...(cur?.pies ?? [])],
          []
        );
        setTotalPies(totalPies?.length ?? 0);
        setPies(
          groupBy(
            totalPies.filter((item) => Boolean(item)),
            "id"
          )
        );
      },
    });
  };

  useEffect(() => {
    if (isEmpty(selWeek)) return;
    loadData();
    //eslint-disable-next-line
  }, [selWeek, selYear]);

  return (
    <div className="mb-5">
      <Paper className="p-5 min-h-120">
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <CustomText variant="body2" bold={600} color="secondary">
              Popular Flavours
            </CustomText>
          </Grid>
          <Grid item>
            <Select
              size="small"
              value={toNumber(selYear)}
              onChange={(e) => setSelYear(e.target.value)}
            >
              {years?.map((item, itemIndex) => (
                <MenuItem value={item} key={itemIndex}>
                  {item}
                </MenuItem>
              ))}
            </Select>
            {/* <CustomText variant="body2" bold={600} color="secondary">
              {new Date().getFullYear()}
            </CustomText> */}
          </Grid>
        </Grid>
        <Grid className="py-3" container spacing={2}>
          <Grid item md={12}>
            <EditFormControl
              type="select"
              fullWidth={true}
              // className="w-60"
              options={weeks}
              optionLabel={(option) => option.label}
              name="selWeek"
              size="small"
              onChange={(e) => setSelWeek(e.target.value)}
              data={{ selWeek: selWeek }}
            />
          </Grid>
          {Object.keys(pies).map((key, keyIndex) => {
            const flavour = pies?.[key]?.[0] ?? {};
            const percent = ((pies?.[key]?.length * 100) / totalPies).toFixed(
              2
            );
            return (
              <Grid key={keyIndex} item lg={12} md={12} sm={12} xs={12}>
                <SimpleProgressCard
                  title={flavour?.name ?? ""}
                  // action={`${toNumber(flavour?.pies)} Pies - ${
                  //   flavour?.percentage
                  // }%`}
                  percentText={`${pies?.[key]?.length} Pies - ${percent}%`}
                  value={percent}
                />
              </Grid>
            );
          })}
        </Grid>
      </Paper>
    </div>
  );
}
